import React, { useState, useEffect } from 'react';
import BoxWrapper from '../boxwra';
import ConfirmationDialog from '../../../Sales/TDSReconciliationSale/ConfirmationDailog';
import { Snackbar, Alert } from '@mui/material';

function Eight({ handleBack, updateTableData, data }) {
  const [tableData, setTableData] = useState(data);
  const [tableName] = useState("8.Other ITC related information");
  const [saveDailogOpen, setSaveDailogOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmBack, setConfirmBack] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // const submitHandle = () => {
  //   updateTableData(tableName, tableData);
  //   setUnsavedChanges(false);
  //   setSaveDailogOpen(false);
  //   setSnackbarOpen(true);
  // };

  const submitHandle = () => {
    // Create a new array with calculated values injected into subtotal rows
    const dataToSubmit = tableData.map((item) => {
      const isSubTotalRow = [
        "(D) Difference [A-(B+C)]",
        "(I) Difference (G-H-H1)",
        "(J) ITC available but not availed on import of goods (Equal to I)",
        "(K) Total ITC to be lapsed in current financial year (E + F + J)",
      ].includes(item.name);

      if (!isSubTotalRow) {
        return item; // Non-calculated rows remain unchanged
      }

      // Calculate live values for all tax fields and inject them
      const fields = ['igst', 'cgst', 'sgst', 'cess'];
      const updatedItem = { ...item };

      fields.forEach((field) => {
        const calculatedValue = getSubTotalRowValue(item, field, tableData);
        updatedItem[field] = calculatedValue;
      });

      return updatedItem;
    });

    // Send the complete data with accurate calculated totals
    updateTableData(tableName, dataToSubmit);

    setUnsavedChanges(false);
    setSaveDailogOpen(false);
    setSnackbarOpen(true);
  };

  const handleBackButton = () => {
    if (unsavedChanges) {
      setConfirmBack(true);
    } else {
      handleBack();
    }
  };

  const confirmBackHandle = () => {
    submitHandle();
    handleBack();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const safeParseFloat = (value) => {
    if (!value || value === '' || value === '-') {
      return 0;
    }
    const stringValue = String(value);
    if (stringValue.endsWith('.')) {
      return 0;
    }
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  };

  const formatRupee = (value, isManualInput = false) => {
    if (isManualInput && (!value || value === 0 || value === '0' || value === '0.00')) {
      return '';
    }
    if (!value && value !== 0) return '';
    const hasDecimal = value.toString().includes('.');
    const decimalPlaces = hasDecimal ? value.toString().split('.')[1]?.length || 0 : 0;
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: hasDecimal && decimalPlaces > 0 ? Math.min(decimalPlaces, 2) : 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value).replace('INR', '₹');
  };

  const parseRupee = (value) => {
    if (!value) return '';
    let cleaned = value.replace(/[^0-9.-]/g, '');
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }
    if (cleaned.startsWith('-')) {
      cleaned = '-' + cleaned.substring(1).replace(/-/g, '');
    } else {
      cleaned = cleaned.replace(/-/g, '');
    }
    return cleaned;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const [itemName, field] = name.split('.');
    const cleanedValue = parseRupee(value);
    setTableData((prevData) =>
      prevData.map((item) =>
        item.name === itemName
          ? { ...item, [field]: cleanedValue }
          : item
      )
    );
    setUnsavedChanges(true);
  };

  const getSubTotalRowValue = (item, key_name, dataToUse = tableData) => {
    let value = 0;
    const getNumericValue = (index, field) => {
      if (!dataToUse[index] || !dataToUse[index][field]) return 0;
      return safeParseFloat(dataToUse[index][field]);
    };

    switch (item.name) {
      case "(D) Difference [A-(B+C)]":
        const a_val = getNumericValue(0, key_name);
        const b_val = getNumericValue(1, key_name);
        const c_val = getNumericValue(2, key_name);
        value = a_val - (b_val + c_val);
        break;

      case "(I) Difference (G-H-H1)":
        const g_val = getNumericValue(6, key_name);
        const h_val = getNumericValue(7, key_name);
        const h1_val = getNumericValue(8, key_name);
        value = g_val - h_val - h1_val;
        break;

      case "(J) ITC available but not availed on import of goods (Equal to I)":
        // ← FIXED: Directly reuse the same calculation as (I) — no need to read stored value
        const g_val_j = getNumericValue(6, key_name);
        const h_val_j = getNumericValue(7, key_name);
        const h1_val_j = getNumericValue(8, key_name);
        value = g_val_j - h_val_j - h1_val_j;
        break;

      case "(K) Total ITC to be lapsed in current financial year (E + F + J)":
        const e_val = getNumericValue(4, key_name);   // E
        const f_val = getNumericValue(5, key_name);   // F
        // Now use live calculation for J instead of stored value
        const g_val_k = getNumericValue(6, key_name);
        const h_val_k = getNumericValue(7, key_name);
        const h1_val_k = getNumericValue(8, key_name);
        const j_live = g_val_k - h_val_k - h1_val_k;  // Live value of (J)
        value = e_val + f_val + j_live;
        break;

      default:
        value = 0;
    }
    return value;
  };

  // const getSubTotalRowValue = (item, key_name, dataToUse = tableData) => {
  //   let value = 0;
  //   const getNumericValue = (index, field) => {
  //     if (!dataToUse[index] || !dataToUse[index][field]) return 0;
  //     return safeParseFloat(dataToUse[index][field]);
  //   };
  //   switch (item.name) {
  //     case "(I) Difference (G-H-H1)":
  //       const g_val = getNumericValue(6, key_name);
  //       const h_val = getNumericValue(7, key_name);
  //       const h1_val = getNumericValue(8, key_name);
  //       value = g_val - h_val - h1_val;
  //       break;
  //     case "(J) ITC available but not availed on import of goods (Equal to I)":
  //       const g_val_j = getNumericValue(6, key_name);
  //       const h_val_j = getNumericValue(7, key_name);
  //       const h1_val_j = getNumericValue(8, key_name);
  //       value = g_val_j - h_val_j - h1_val_j;
  //       break;
  //     case "(K) Total ITC to be lapsed in current financial year (E + F + J)":
  //       const e_val = getNumericValue(4, key_name);
  //       const f_val = getNumericValue(5, key_name);
  //       const j_val = getNumericValue(10, key_name);
  //       value = e_val + f_val + j_val;
  //       break;
  //     default:
  //       value = 0;
  //   }
  //   return value; // Return raw number for proper formatting
  // };

  const renderTableRows = () => {
    const getRowColor = (index) => {
      const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
      return colors[index % colors.length];
    };

    return tableData.map((item, index) => {
      const isSubTotalRow = [
        "(D) Difference [A-(B+C)]",
        "(I) Difference (G-H-H1)", // ← FIXED: removed " above)"
        "(J) ITC available but not availed on import of goods (Equal to I)",
        "(K) Total ITC to be lapsed in current financial year (E + F + J)",
      ].includes(item.name);

      const isManualInputRow = !isSubTotalRow && (item.manual_type !== false);

      return (
        <div
          key={index}
          style={{
            display: 'grid',
            gridTemplateColumns: '60px 1fr 150px 150px 150px 150px',
            gap: '10px',
            alignItems: 'center',
            padding: '8px 10px',
            borderBottom: '1px solid #f1f5f9',
            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
            borderRadius: '6px',
            marginBottom: '2px',
            minHeight: '50px',
          }}
        >
          <span
            style={{
              color: '#1e293b',
              fontSize: '13px',
              fontWeight: '600',
              textAlign: 'center',
              padding: '8px 6px',
              backgroundColor: getRowColor(index),
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {index + 1}
          </span>
          <span
            style={{
              color: '#334155',
              fontSize: '13px',
              padding: '8px 12px',
              backgroundColor: '#f1f5f9',
              borderRadius: '6px',
              wordBreak: 'break-word',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              minHeight: '34px',
            }}
          >
            {item.name}
          </span>
          {['igst', 'cgst', 'sgst', 'cess'].map((field) => {
            let displayValue;
            if (isSubTotalRow) {
              // ← FIXED: Use latest tableData for live calculation
              const liveValue = getSubTotalRowValue(item, field, tableData);
              displayValue = formatRupee(liveValue);
            } else if (isManualInputRow) {
              const rawVal = item[field];
              const numVal = safeParseFloat(rawVal);
              const stringVal = String(rawVal || '');
              displayValue = (rawVal === '' || rawVal === '-' || stringVal.endsWith('.')) ? rawVal : formatRupee(numVal, true);
            } else {
              displayValue = formatRupee(item[field], isManualInputRow) || '';
            }

            return (
              <input
                key={`${item.name}.${field}`}
                type="text"
                name={`${item.name}.${field}`}
                value={displayValue}
                onChange={handleInputChange}
                readOnly={isSubTotalRow || !isManualInputRow}
                style={{
                  color: '#1e293b',
                  fontWeight: '500',
                  fontSize: '13px',
                  textAlign: 'right',
                  padding: '8px 12px',
                  backgroundColor: isSubTotalRow || !isManualInputRow ? '#f0f0f0' : '#ecfdf5',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  outline: 'none',
                  cursor: isSubTotalRow || !isManualInputRow ? 'not-allowed' : 'text',
                  minHeight: '34px',
                  boxSizing: 'border-box',
                  width: '100%',
                  ...(isSubTotalRow ? { fontWeight: 'bold', borderColor: 'green', borderWidth: '2px' } : {}),
                }}
                onFocus={(e) => {
                  if (!isSubTotalRow && isManualInputRow) {
                    const rawVal = item[field] || '';
                    e.target.value = rawVal;
                    e.target.style.borderColor = '#88d8a3';
                    e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
                  }
                }}
                onBlur={(e) => {
                  if (!isSubTotalRow && isManualInputRow) {
                    const rawVal = e.target.value;
                    const cleanedVal = parseRupee(rawVal);
                    const numVal = safeParseFloat(cleanedVal);
                    const stringVal = String(cleanedVal || '');
                    const finalDisplay = (cleanedVal === '' || cleanedVal === '-' || stringVal.endsWith('.')) ? cleanedVal : formatRupee(numVal, true);
                    e.target.value = finalDisplay;
                    setTableData((prevData) =>
                      prevData.map((it) =>
                        it.name === item.name
                          ? { ...it, [field]: cleanedVal }
                          : it
                      )
                    );
                    e.target.style.borderColor = '#e2e8f0';
                    e.target.style.boxShadow = 'none';
                  }
                }}
              />
            );
          })}
        </div>
      );
    });
  };

  useEffect(() => {
    console.log('Eight tableData updated:', tableData);
  }, [tableData]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '30px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        <BoxWrapper
          backButtonForZohoEnable={true}
          backButton={handleBackButton}
          boxTitle={tableName}
        >
          <p style={{ marginLeft: '10px' }}>
            <span style={{ fontWeight: 'bold' }}>Note: </span> The fields where the system computed values would be modified by more/less 20% shall be highlighted in <span style={{ color: 'red' }}>Red</span> for reference and attention.
          </p>
          <hr style={{ marginLeft: '10px' }} />
        </BoxWrapper>

        <div
          style={{
            maxHeight: 'calc(100vh - 450px)',
            overflowY: 'auto',
            marginTop: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '60px 1fr 150px 150px 150px 150px',
              gap: '10px',
              alignItems: 'center',
              padding: '8px 10px',
              borderBottom: '2px solid #e2e8f0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              marginBottom: '2px',
              minHeight: '50px',
              fontWeight: '600',
              color: '#475569',
              fontSize: '13px',
              position: 'sticky',
              top: '0',
              zIndex: '10',
            }}
          >
            <span style={{ textAlign: 'center', padding: '8px 6px', backgroundColor: '#e0e7ff', borderRadius: '6px' }}>
              S.No.
            </span>
            <span style={{ textAlign: 'left', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px' }}>
              Description
            </span>
            <span style={{ textAlign: 'right', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px' }}>
              Integrated Tax (₹)
            </span>
            <span style={{ textAlign: 'right', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px' }}>
              Central Tax (₹)
            </span>
            <span style={{ textAlign: 'right', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px' }}>
              State/UT Tax (₹)
            </span>
            <span style={{ textAlign: 'right', padding: '8px 12px', backgroundColor: '#f1f5f9', borderRadius: '6px' }}>
              CESS (₹)
            </span>
          </div>

          {tableData && tableData.length >= 1 ? (
            renderTableRows()
          ) : (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No Data Found!
            </div>
          )}
        </div>

        <div
          style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f8fafc',
            borderRadius: '8px',
            borderTop: '2px solid #e2e8f0',
          }}
        >
          <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
            Total Records: {tableData?.length || 0}
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', gap: '10px' }}>
          <button
            type="button"
            onClick={() => setSaveDailogOpen(true)}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
            }}
          >
            Save
          </button>
        </div>
      </div>

      <ConfirmationDialog
        open={saveDailogOpen}
        onClose={() => setSaveDailogOpen(false)}
        onConfirm={submitHandle}
        title="Confirm Save"
        text="Do you want to save your changes? This action will update the current data."
      />
      <ConfirmationDialog
        open={confirmBack}
        onConfirm={confirmBackHandle}
        onClose={() => handleBack()}
        title="Unsaved Changes"
        text="You have unsaved changes. Do you want to leave without saving?"
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000} // Auto-close after 3 seconds
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          Data saved successfully!
        </Alert>
      </Snackbar>

    </div>
  );
}

export default Eight;